import * as http from '@/api/config';

/* 获取淘客商品 */
export function getAdminTaokeGoodsList(data) {
    const url = 'taoke/admin/v1/goods/list';
    return http.$get(url, data);
}



// WEBPACK FOOTER //
// ./src/api/module/taoke.js